import { render, staticRenderFns } from "./CenterGoogleTrend.vue?vue&type=template&id=0a2e7d2c&scoped=true&lang=pug"
import script from "./CenterGoogleTrend.vue?vue&type=script&lang=js"
export * from "./CenterGoogleTrend.vue?vue&type=script&lang=js"
import style0 from "./CenterGoogleTrend.vue?vue&type=style&index=0&id=0a2e7d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e7d2c",
  null
  
)

export default component.exports